import { useNavigate } from "react-router-dom";
import { AccountConfirmedPageTemplate } from "./template";
import { useAccountConfirmedPage } from "./logic";

export const AccountConfirmedPage = (): JSX.Element => {
  const props = useAccountConfirmedPage();
  return (
    <AccountConfirmedPageTemplate {...props}/>
  );
}; 